export enum FeaturesAmlDeskWithGrants {
  RiskAnalysis = 'RiskAnalysis',
  KnowYourCustomer = 'KnowYourCustomer',
  LocationAnalysis = 'LocationAnalysis',
}
